import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import styled, { keyframes } from 'styled-components';

// Animation for floating effect
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

// Styled components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem;
  text-align: center;
`;

const ErrorCode = styled.h1`
  font-size: 8rem;
  margin: 0;
  background: linear-gradient(to right, #667eea, #764ba2);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 900;
`;

const ErrorImage = styled.div`
  width: 200px;
  height: 200px;
  margin: 2rem 0;
  background: url('https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif') center no-repeat;
  background-size: contain;
  animation: ${float} 3s ease-in-out infinite;

  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
`;

const ErrorTitle = styled.h2`
  font-size: 2rem;
  color: #2d3748;
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  font-size: 1.2rem;
  color: #4a5568;
  max-width: 600px;
  margin-bottom: 2rem;
`;

const HomeButton = styled.button`
  padding: 12px 30px;
  background: linear-gradient(to right, #667eea, #764ba2);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
  }

  &:active {
    transform: translateY(1px);
  }
`;
export const PageNotFound = () => {
 const navigate = useNavigate();
 useEffect(() => {
    // This doesn't actually set the HTTP status code,
    // but it updates the browser history state to include a status code
    window.history.replaceState(
      { status: 404 },
      '404 - Not Found',
      window.location.pathname
    );
    
    // You can also set the document title
    document.title = '404 - Page Not Found';
  }, []);


  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <ErrorImage />
      <ErrorTitle>Oops! Page Not Found</ErrorTitle>
      <ErrorMessage>
        The page you're looking for might have been removed, had its name changed, or is temporarily unavailable.
      </ErrorMessage>
      <HomeButton onClick={() => navigate('/')}>Go to Homepage</HomeButton>
    </Container>
  )
}
